import script from "./DomainSelectedSuccessfullyView.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainSelectedSuccessfullyView.vue?vue&type=script&setup=true&lang=js"

import "./DomainSelectedSuccessfullyView.vue?vue&type=style&index=0&id=15470dbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15470dbe"]])

export default __exports__